import React, { useEffect, useState } from 'react'
import { StyleSheet, Text, View, TouchableOpacity, Image } from 'react-native'
import { FormContentsModel, ModelAnswerFromProps } from '../models/StoreDetailModel'
import { SiNoNaButton } from './SiNoNaItem'
import { useNavigation } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { DotsNavigation } from '../../navigation/stacks/NavigationStack'
import { schedulesServices } from '../../../../database/schedules.database'
import { updateFormAnswerSchedule, getFormsAnswersInStore } from '../../../../db-sqlite/repositories/schedule.repository'
import { useBottomSheet } from '../../customUtils/context/BottomSheetContext'
import { fetchAuthSession } from 'aws-amplify/auth'
import { request_save_form } from '../../../services/schedule.services'
import { useFormRefrigeratorContext, useFormContext } from '../context/form.context'
import { useStoreContext } from '../context/store.context'
import { removeCacheByFragment } from '../../../utils/FetchServices'
import theme from '../../../../theme'
import styles from './InputFormItemStyles'
import { getLanguage } from '../../appBar/context/LocalizationContext'
import { ImageWithZoom } from '../../customUtils/Components/ImageWIthZoom'
import { PATH_ASSETS } from '../../../utils/Constants'
import useImageLoader from '../../../hooks/useImageLoader'
import { Loader } from '../../customUtils/Components/Loader'
import { getOrCreateFormDayUniqueId } from '../../../utils/formDayUniqueIdStore' // ✅ Importar store

// Normaliza distintos tipos que puede traer la DB para `active`
const parseActive = (rawActive: any): boolean => {
    if (rawActive === undefined || rawActive === null) return true
    if (typeof rawActive === 'boolean') return rawActive
    if (typeof rawActive === 'number') return rawActive === 1
    if (typeof rawActive === 'string') {
        const v = rawActive.trim().toLowerCase()
        return v === '1' || v === 'true'
    }
    return Boolean(rawActive)
}

interface InputFormItemI {
    item: FormContentsModel
    form_id: string
    schedule_id: string
    store_id: string
    checkComplete: (option?: ModelAnswerFromProps) => void
    checkin_id: string
}

export const InputFormItem = React.memo(({ item, form_id, schedule_id, store_id, checkComplete, checkin_id }: InputFormItemI) => {
    const navigation = useNavigation<StackNavigationProp<DotsNavigation>>()
    const { form_refrigerators_main, getFormRefrigerator, updateActveFormRefrigerator, reloadActive, deleteQuestionForm } =
        useFormRefrigeratorContext()
    const { currentCheckin, formsContext, updateStatusProgressForm } = useFormContext()
    const { setReloadFormsFn } = useStoreContext()
    const { formQuestions } = getFormRefrigerator(form_refrigerators_main, form_id)
    const { openBottomSheet, closeBottomSheet } = useBottomSheet()
    const [selectedIndex, setSelectedIndex] = useState(-1)
    const [active, setActive] = useState(true)
    const { image, loading, placeholderGeneral } = useImageLoader(item.media, PATH_ASSETS)
    const [preview, setPreview] = useState(image)

    useEffect(() => {
        setPreview(image)
    }, [image])
    useEffect(() => {
        if (formQuestions && formQuestions.length > 0) {
            const findIndex = formQuestions.findIndex((quest) => quest._id === item._id)
            if (findIndex !== -1) {
                const raw = formQuestions[findIndex]['active']
                const parsedActive = parseActive(raw)
                setActive(parsedActive)

                const idx = formQuestions[findIndex]['index']

                if (parsedActive && (idx === undefined || idx === null)) {
                    setSelectedIndex(-1)
                }

                if (!parsedActive) {
                    if (idx !== undefined && idx !== null) {
                        setSelectedIndex(idx)
                    } else {
                        setSelectedIndex(0)
                    }
                }
            }
        }
    }, [item, reloadActive])

    const handleQuestion = async (index: number) => {
        console.log('Index selected heladera', index)
        console.log('Item heladera', item)
        // if (index === selectedIndex) {
        //     return
        // }
        // setSelectedIndex(index)

        const action = item.secondary_actions[index]
        console.log('Action selected heladera: ', action)
        console.log('Action selected heladera form: ', action['form'])

        let answer: ModelAnswerFromProps = {
            _id: item._id,
            option_selected_text: [item.secondary_actions[index].label],
            option_selected_id: [item.secondary_actions[index]._id],
            question_id: item._id,
            media: '',
            question_text: item.title,
            score: item.secondary_actions[index].score ? item.secondary_actions[index].score.toString() : '0',
            status: 1,
            date_finish: new Date().toString(),
            date_init: new Date().toString(),
            question_input: '',
            index: index,
            field_media: '',
            field_text: '',
            questionScore: item.questionScore,
            type: item.input_type.type,
            ponderar: item.questionScore && item.questionScore > 0, // [7, 8, 14, 18].includes(item.input_type.type),

            question: item.title,
            questionOptionSelected: [item.secondary_actions[index]._id],
            questionOptionSelectedText: [item.secondary_actions[index].label],
            questionType: {
                title: item.input_type.title,
                type: item.input_type.type,
                id: item.input_type._id,
            },
            questionPrice: '',
            description: '',
            tag: '',
            questionImage: '',
            questionInput: '',
        }

        if (action.refrigerator_id) {
            answer.refrigerator_id = action.refrigerator_id
        }

        if (action && action['form'] && action['form'].length > 0) {
            const childForm = action['form'][0]

            // ✅ SOLUCIÓN SIMPLE: Pasar los valores como parámetros de navegación
            console.log('📝 Navegando a formulario hijo con parámetros:', {
                form_id: childForm._id,
                refrigerator_id: childForm.refrigerator_id,
                form_id_father: form_id,
                heladera: 1,
                question_id: item._id,
            })

            // Guardar respuesta en el formulario padre
            await checkComplete(answer)
            setSelectedIndex(index)

            // Navegar pasando los valores necesarios como parámetros
            navigation.push('ExecutionView', {
                forms: action['form'],
                selectedIndex: 0,
                schedule_id: schedule_id,
                store_id: store_id,
                storeInfo: null,
                checkin_id: null,
                // ✅ Parámetros adicionales para formularios de heladera
                refrigerator_id: childForm.refrigerator_id, // ID del refrigerador específico
                form_id_father: form_id, // ID del formulario padre
                heladera: true, // Indica que es formulario de heladera
                question_id: item._id, // ID de la pregunta que generó la heladera
            })
        } else {
            openBottomSheet(
                <AlertSentAnswer
                    closeBottomSheet={closeBottomSheet}
                    button
                    title={'¿Deseas eliminar la heladera?'}
                    desc={'Si confirmas, la heladera quedará desvinculada de esta tienda.'}
                    fnButtonCancel={() => fnButtonCancel(index, answer)}
                    loaderOnConfirm={true}
                />,
            )
        }
    }

    const fnButtonCancel = async (index: number, answer: ModelAnswerFromProps) => {
        try {
            console.log('173 ---- fnButtonCancel: Iniciando proceso de eliminación de heladera')
            console.log('174 ---- fnButtonCancel: Parámetros recibidos => index:', index, ', answer:', answer)
            setSelectedIndex(index)

            const remplaceAnswers = true

            // ✅ Obtener day_unique_id del store
            const dayUniqueId = getOrCreateFormDayUniqueId(form_id, schedule_id, store_id)

            await updateFormAnswerSchedule({ newAnswer: answer, schedule_id, form_id, store_id, replaceAnswers: remplaceAnswers, clearAnswers: false, type: 'null', day_unique_id: dayUniqueId })
            await checkComplete(answer)

            const session = await fetchAuthSession()
            const authToken = session.tokens?.accessToken?.toString() || ''
            let dif_utc = -new Date().getTimezoneOffset() / 60
            const { answers, date_init, progress_questions_yes_na, heladera, create_refrigerator, type_form, form_id_father } =
                await schedulesServices.getFormsAnswers(schedule_id, form_id, store_id)

            let obj_json_raw = {
                answers: answers,
                date_finish: new Date().toISOString(),
                date_init: date_init,
                id_activity: form_id,
                status: 0,
                progress: progress_questions_yes_na,
                score: progress_questions_yes_na,
                heladera: heladera,
                create_refrigerator: create_refrigerator,
                input_type: type_form['type'],
            }

            // Evitar enviar id_activity con valor '0' — comprobar explícitamente
            if (form_id_father && form_id_father !== '' && form_id_father != '0') {
                obj_json_raw.id_activity = form_id_father
            }

            let json_raw = [obj_json_raw]

            let data_checkin_id

            if (!checkin_id && store_id) {
                // si no existe lo busco en local

                const checkin = await schedulesServices.get_checkin(store_id, schedule_id)
                if (checkin && checkin.length > 0) {
                    const index = checkin.length - 1
                    data_checkin_id = checkin[index].checkin_id
                } else {
                    data_checkin_id = currentCheckin
                }
            } else {
                data_checkin_id = checkin_id ?? currentCheckin
            }

            const data = {
                authToken: authToken,
                body: {
                    form: JSON.stringify(json_raw),
                    process_now: true,
                    date: new Date().toISOString(),
                    schedule_id: schedule_id,
                    checkin_id: data_checkin_id,
                    dif_utc: dif_utc.toString(),
                },
            }
            console.log('217 ---- fnButtonCancel: Datos preparados para request_save_form json_raw => ', JSON.stringify(json_raw))
            const res = await request_save_form(data)

            console.log('217 ---- fnButtonCancel: Respuesta de request_save_form => ', res)

            if (res && res.status && res.response.status) {
                // ✅ Actualizar estado local INMEDIATAMENTE para feedback visual
                console.log('✅ fnButtonCancel: Actualizando estado local para deshabilitar visualmente')
                setActive(false)
                setSelectedIndex(index)
                
                // ✅ FIX: NO actualizar BD después de enviar - mantener respuesta guardada para reconstrucción
                // La respuesta ya fue enviada al servidor, ahora solo sincronizamos el status
                
                // ✅ FIX: Sincronizar el status del formulario después de borrar heladera
                // Obtener el nuevo status desde la BD y actualizar el contexto
                console.log('🔄 fnButtonCancel: Sincronizando status del formulario después de borrar heladera')
                const { progress_questions_yes_na, status } = await getFormsAnswersInStore(schedule_id, form_id, store_id)
                console.log('📊 fnButtonCancel: Status actualizado:', { status, progress_questions_yes_na })
                updateStatusProgressForm(formsContext, schedule_id, form_id, store_id, status, progress_questions_yes_na)
                
                const activeContext = false
                console.log('🚀 ~ fnButtonCancel: Actualizando formulario de heladera a inactive => ', {
                    form_id,
                    item_id: item._id,
                    active: activeContext,
                })
                updateActveFormRefrigerator(form_refrigerators_main, form_id, item._id, activeContext, index)

                // ✅ Limpiar cache de get_store para obtener data fresca con la heladera actualizada
                
                // ✅ Disparar recarga para actualizar el contexto desde el servidor
                console.log('🔄 fnButtonCancel: Disparando recarga de formularios')
                setReloadFormsFn()
                removeCacheByFragment('get_store')
            }

            closeBottomSheet(true)
        } catch (error) {
            console.error('173 ---- fnButtonCancel: ERROR => ', error)
            throw new Error(error)
        }
    }
    const openBigImage = () => {
        if (image) {
            openBottomSheet(<ImageWithZoom uri={image} contentSeen={() => {}} path={''} />, undefined, undefined, true, true, true)
        }
    }
    return (
        <View style={!active ? styles.containerInactive : styles.containerActive}>
            <View style={[styles.container]}>
                {item.media && (
                    <TouchableOpacity onPress={() => openBigImage()}>
                        {loading ? (
                            <Loader />
                        ) : (
                            <Image
                                style={styles.image}
                                source={{ uri: preview }}
                                onError={(e) => {
                                    setPreview(placeholderGeneral)
                                }}
                            />
                        )}
                    </TouchableOpacity>
                )}
                <View style={{ flex: 1 }}>
                    {item.title && <Text style={styles.itemText}>{item.title}</Text>}
                    {item.description && <Text style={styles.itemText}>{item.description}</Text>}
                </View>

                <View style={[styles.flexDirectionRow]}>
                    {item.secondary_actions &&
                        item.secondary_actions.map((action, index) => {
                            const isSelected = selectedIndex === index

                            return (
                                <SiNoNaButton
                                    key={action._id.toString()}
                                    name={action.label}
                                    index={index}
                                    onClickTag={!active ? () => {} : () => handleQuestion(index)}
                                    isSelected={isSelected}
                                />
                            )
                        })}
                </View>
            </View>
            <View style={styles.dividerHorizontalLine}></View>
        </View>
    )
})

interface AlertSentAnswerI {
    button: boolean
    closeBottomSheet: (l) => void
    title: string
    desc: string
    fnButtonCancel: () => Promise<void>
    loaderOnConfirm?: boolean
}

export const AlertSentAnswer = ({ button = false, closeBottomSheet, title, desc, fnButtonCancel, loaderOnConfirm = false }: AlertSentAnswerI) => {
    const { languageFile } = getLanguage()
    const [showLoader, setShowLoader] = useState(false)
    const handleConfirm = async () => {
        if (loaderOnConfirm) setShowLoader(true)
        await fnButtonCancel()
        if (loaderOnConfirm) setShowLoader(false)
    }

    const handleCancel = () => {
        try {
            closeBottomSheet(true)
        } catch (error) {
            console.error('233 ---- handleCancel: ERROR => ', error)
        }
    }

    return (
        <View style={styles.contentContainer}>
            <View style={styles.messageContainer}>
                <View>
                    <Image style={styles.imageAsset} source={require('../../../../assets/stores/refrigeratorRemoved.png')} resizeMode='contain' />
                </View>
                <Text style={styles.titleText}>{title}</Text>
                <Text style={styles.descriptionText}>{desc}</Text>
            </View>

            <View style={styles.spacer} />

            <View style={styles.containerButton}>
                <TouchableOpacity style={styles.mainButton} onPress={handleConfirm}>
                    <Text style={styles.mainButtonText}>{languageFile.confirm}</Text>
                </TouchableOpacity>

                {button && (
                    <TouchableOpacity style={styles.secondaryButton} onPress={handleCancel}>
                        <Text style={styles.secondaryButtonText}>{languageFile.cancel}</Text>
                    </TouchableOpacity>
                )}
            </View>
            {showLoader && (
                <View style={{ position: 'absolute', inset: 0, backgroundColor: 'white' }}>
                    <Loader />
                </View>
            )}
        </View>
    )
}
